import { Component } from '@angular/core';

@Component({
  selector: 'app-investor-guide',
  templateUrl: './investor-guide.component.html',
  styleUrl: './investor-guide.component.scss'
})
export class InvestorGuideComponent {

}
